<div class="card" id="edit-promises">
    <div class="card-body">
        @if (sale) {
            <h3 class="card-title">{{sale.vehicle}}</h3>
        }
        @if (sale) {
            <p class="card-subtitle text-muted">{{sale.stock}} | {{sale.vin}}</p>
        }
        <form [formGroup]="form">
            <ul class="list-group list-group-flush pay-promise-list" formArrayName="promises">
                @if (form.get('promises').hasError('totalExceedsDueAmount')) {
                    <li class="list-group-item">
                        <div class="alert alert-danger" role="alert">Total of all promises cannot exceed the amount past due.</div>
                    </li>
                }

                @for (promiseForm of promises.controls; track promiseForm; let i = $index) {
                    <li class="list-group-item">
                        <form [formGroup]="promiseForm">
                            <div class="form-row">
                                <div class="col">
                                    <div class="form-group">
                                        <input type="date" [id]="'promise-to-pay-due-' + i" class="form-control form-control-sm" formControlName="due" placeholder="due" />
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="form-group">
                                        <currency-input [id]="'promise-to-pay-amount-' + i" [control]="promiseForm.get('amount')"></currency-input>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <input type="text" [id]="'promise-to-pay-note-' + i" class="form-control form-control-sm" formControlName="note" placeholder="note" />
                            </div>
                        </form>
                        <div class="action-bar">
                            <button type="button" class="btn btn-sm btn-link" (click)="delete(promiseForm.get('id').value, i)"><span class="text-danger">discard</span></button>
                            @if (promiseForm.get('id').value) {
                                <button type="button" class="btn btn-sm btn-link" (click)="close(promiseForm.get('id').value, i)"><span class="text-primary">mark as fulfilled</span></button>
                            }
                        </div>
                    </li>
                }
                <li class="button-bar list-group-item">
                    <button type="button" class="btn btn-sm btn-link" (click)="add($event)"><span class="text-success"><span class="uil-plus"></span> Add promise</span></button>
                    <div class="end-actions">
                        <button type="button" class="btn btn-sm btn-link" (click)="cancel($event)"><span class="text-danger">cancel</span></button>
                        <button type="submit" class="btn btn-sm btn-primary" (click)="save($event)" [disabled]="form.invalid">Save All</button>
                    </div>
                </li>
            </ul>
        </form>
    </div>
</div>